const forms = {
  onRequest: "Op verzoek", // translated
  person: "persoon", // translated
  travelDate: "Reis datum", // translated
  cancel: "Annuleren", // translated
  getPrice: "Prijs ophalen", // translated
  travelDates: "Reis data", // translated
};


export default forms;
